import { PropertyContainer as Property } from "./Property.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default Property;
